<template>
  <Teleport to="#modal">
    <CModal v-bind="$attrs" :class="modalClass" :has-slots="hasSlots" :should-hide-overflow="shouldHideOverflow">
      <template #header>
        <slot name="header" />
      </template>
      <template #body>
        <slot name="body" />
      </template>
      <template #footer>
        <slot name="footer" />
      </template>
    </CModal>
  </Teleport>
</template>

<script setup lang="ts">
const slots = useSlots();
const hasSlots = computed(() => ({
  header: !!slots.header,
  body: !!slots.body,
  footer: !!slots.footer,
}));
</script>

<script lang="ts">
export default {
  name: 'ModalPortal',
  inheritAttrs: false,
  props: {
    modalClass: {
      type: String,
      default: '',
    },
    shouldHideOverflow: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
